export function timeAgo(date: number) {
  let duration = Math.floor((Date.now() - date) / 1000);
  if (duration < 0) {
    return "---";
  }

  if (duration < 60) {
    return `${(duration % 60).toString()}s`;
  }

  duration = Math.floor(duration / 60);
  if (duration < 60) {
    return `${(duration % 60).toString()}m`;
  }

  duration = Math.floor(duration / 60);
  return `${duration.toString()}h`;
}
